/* eslint-disable react-hooks/exhaustive-deps */

import * as React from 'react';
import { ApiException } from '@careerhub/api';
import { Provider } from 'react-redux';
import { SectionLoader, NoAccessPage } from '../components';
import { CareerHubModuleReactContext } from '../context';
import { ICareerHubModuleConfig, IModuleStoreBuilderResult, ICareerHubModuleContext } from '../models';
import { LoadingStates } from '../store';
import { careerHubModule } from './careerHubModule';

export type CareerHubModuleContainerProps = React.PropsWithChildren<{ config: ICareerHubModuleConfig }>;

/** Wraps the Career Hub app to provide authentication and copilot access */
export function CareerHubModuleContainer(props: CareerHubModuleContainerProps): React.ReactElement {
  const [isAuthorized, setIsAuthorized] = React.useState<boolean | undefined>(undefined);
  const [loadingState, setLoadingState] = React.useState(LoadingStates.NOT_STARTED);
  const [moduleStore, setModuleStore] = React.useState<IModuleStoreBuilderResult<ICareerHubModuleContext, {}>>();
  // Initialize app context
  React.useEffect(() => {
    if (loadingState == LoadingStates.NOT_STARTED) {
      setLoadingState(LoadingStates.STARTED);
      careerHubModule
        .initialize(props.config)
        .then((storeResult: IModuleStoreBuilderResult<ICareerHubModuleContext, {}>) => {
          setModuleStore(storeResult);
          setIsAuthorized(true);
          setLoadingState(LoadingStates.SUCCEEDED);
        })
        .catch((reason) => {
          // TODO: Will add logging.
          console.log(reason);
          var apiError = reason as ApiException;
          if (apiError.status === 403) {
            setIsAuthorized(false);
          }
          setLoadingState(LoadingStates.FAILED);
        });
    }
  }, [loadingState, props]);

  return (
    <SectionLoader announce state={loadingState} errorComponent={isAuthorized === false ? <NoAccessPage /> : undefined}>
      <>
        {moduleStore && (
          <Provider store={moduleStore.store}>
            <CareerHubModuleReactContext.Provider value={moduleStore.context}>
              {props.children}
            </CareerHubModuleReactContext.Provider>
          </Provider>
        )}
      </>
    </SectionLoader>
  );
}
